/*
 * Type enum.
 */

import {PredicateOf} from '../../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {ClientRuleAction} from '../../../../ruleActionModel';
import {UnrepliedAfterCondition} from '../../../../ruleConditionModel';
import {SlaEditorSubsetsEnum} from './slaEditorState';

export enum SlaEditorActionTypesEnum {
  SET_BREACH_UNREPLIED = '@@sla_editor/SET_BREACH_UNREPLIED',
  SET_WARNING_UNREPLIED = '@@sla_editor/SET_WARNING_UNREPLIED',

  ADD_ACTION = '@@sla_editor/ADD_ACTION',
  UPDATE_ACTION = '@@sla_editor_UPDATE_ACTION',
  DELETE_ACTION = '@@sla_editor_DELETE_ACTION',

  SET_TAG = '@@sla_editor/SET_TAG',
}

/*
 * Types.
 */

interface SetBreachUnrepliedAction {
  type: SlaEditorActionTypesEnum.SET_BREACH_UNREPLIED;
  payload: UnrepliedAfterCondition;
}

interface SetWarningUnrepliedAction {
  type: SlaEditorActionTypesEnum.SET_WARNING_UNREPLIED;
  payload: UnrepliedAfterCondition | undefined;
}

interface AddActionAction {
  type: SlaEditorActionTypesEnum.ADD_ACTION;
  payload: {
    action: ClientRuleAction;
    subset: SlaEditorSubsetsEnum;
  };
}

interface UpdateActionAction {
  type: SlaEditorActionTypesEnum.UPDATE_ACTION;
  payload: {
    predicate: PredicateOf<ClientRuleAction>;
    update(action: ClientRuleAction): ClientRuleAction;
    subset: SlaEditorSubsetsEnum;
  };
}

interface DeleteActionAction {
  type: SlaEditorActionTypesEnum.DELETE_ACTION;
  payload: {
    predicate: PredicateOf<ClientRuleAction>;
    subset: SlaEditorSubsetsEnum;
  };
}

interface SetTagAction {
  type: SlaEditorActionTypesEnum.SET_TAG;
  payload: {
    tagId: number | undefined;
    subset: SlaEditorSubsetsEnum;
  };
}

export type SlaEditorSpecificAction =
  | SetBreachUnrepliedAction
  | SetWarningUnrepliedAction
  | AddActionAction
  | UpdateActionAction
  | DeleteActionAction
  | SetTagAction;
